//Get Reducer Call--->
export const getSalesRequest = (
    page: number,
    size: number,
    search: string,
    collection_day: string,
    payment_status: string,
    area_id: string,
    landmark_id: string,
    from_date: string,
    to_date: string,
    product_id: string
) => ({
    type: 'GET_SALES_REQUEST',
    payload: {
        page,
        size,
        search,
        collection_day,
        payment_status,
        area_id,
        landmark_id,
        from_date,
        to_date,
        product_id,
    },
});

export const getSalesNoRequest = (collection_day: string) => ({
    type: 'GET_SALES_NO_REQUEST',
    payload: { collection_day },
});

export const getSalesNoSuccess = (data: any) => ({
    type: 'GET_SALES_NO_SUCCESS',
    payload: { data },
});

export const getSalesNoFailure = (data: string) => ({
    type: 'GET_SALES_NO_FAILURE',
    payload: { data },
});

export const resetGetSalesNo = () => ({
    type: 'RESET_GET_SALES_NO',
});

export const getSalesSuccess = (data: any) => ({
    type: 'GET_SALES_SUCCESS',
    payload: { data },
});

export const getSalesFailure = (data: string) => ({
    type: 'GET_SALES_FAILURE',
    payload: { data },
});

export const resetGetSales = () => ({
    type: 'RESET_GET_SALES',
});

//Create Reducer Call--->
export const createSalesRequest = (data: any) => ({
    type: 'CREATE_SALES_REQUEST',
    payload: data,
});

export const createSalesSuccess = (data: any) => ({
    type: 'CREATE_SALES_SUCCESS',
    payload: { data },
});

export const createSalesFailure = (data: string) => ({
    type: 'CREATE_SALES_FAILURE',
    payload: { data },
});

export const resetCreateSales = () => ({
    type: 'RESET_CREATE_SALES',
});

//Update Reducer Call--->
export const updateSalesRequest = (data: any, id: string) => ({
    type: 'UPDATE_SALES_REQUEST',
    payload: { data, id },
});

export const updateSalesSuccess = (data: any) => ({
    type: 'UPDATE_SALES_SUCCESS',
    payload: { data },
});

export const updateSalesFailure = (data: string) => ({
    type: 'UPDATE_SALES_FAILURE',
    payload: { data },
});

export const resetUpdateSales = () => ({
    type: 'RESET_UPDATE_SALES',
});
//Delete Reducer Call--->
export const deleteSalesRequest = (id: string) => ({
    type: 'DELETE_SALES_REQUEST',
    payload: { id },
});

export const deleteSalesDetailsRequest = (id: string) => ({
    type: 'DELETE_SALES_DETAIL_REQUEST',
    payload: { id },
});

export const deleteSalesSuccess = (data: any) => ({
    type: 'DELETE_SALES_SUCCESS',
    payload: { data },
});

export const deleteSalesFailure = (data: string) => ({
    type: 'DELETE_SALES_FAILURE',
    payload: { data },
});

export const resetDeleteSales = () => ({
    type: 'RESET_DELETE_SALES',
});
